import { Button, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../../Loading";
import FormError from "../../components/FormError";
import { ApiError } from "../../lib/api";
import HouseholdGroupBilling from "./HouseholdGroupBilling";
import HouseholdGroupMembership from "./HouseholdGroupMembership";
import HouseholdGroupStatements from "./HouseholdGroupStatements";
import { useQueryHouseholdGroup } from "./lib";

/**
 * One household group's page: its name, its dissolved state, and its sections.
 * A read that fails with status 404 or 400 (a group of no firm or of another
 * firm; an id that is not a number) shows "Household group not found" with no
 * retry; each other failure shows "Failed to load household group" with
 * "Try again".
 */
const HouseholdGroupInfo = () => {
  const { groupId } = useParams();

  const {
    isPending,
    isError,
    error,
    refetch,
    data: group,
  } = useQueryHouseholdGroup(parseInt(groupId ?? ""));

  return isPending ? (
    <Loading />
  ) : isError &&
    error instanceof ApiError &&
    (error.status === 404 || error.status === 400) ? (
    <FormError message="Household group not found" />
  ) : isError || !group ? (
    <>
      <FormError message="Failed to load household group" />
      <Button variant="outline-primary" size="sm" onClick={() => refetch()}>
        Try again
      </Button>
    </>
  ) : (
    <>
      <Row className="mb-3">
        <Col>
          <h1>{group.name}</h1>
          {group.dissolvedEffectiveDate == null ? null : (
            <div>Archived {group.dissolvedEffectiveDate}</div>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <HouseholdGroupMembership
            householdGroupId={group.householdGroupId}
            householdGroupName={group.name}
            dissolvedEffectiveDate={group.dissolvedEffectiveDate ?? null}
            members={group.members ?? []}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <HouseholdGroupBilling group={group} />
        </Col>
      </Row>
      <Row>
        <Col>
          <HouseholdGroupStatements householdGroupId={group.householdGroupId} />
        </Col>
      </Row>
    </>
  );
};

export default HouseholdGroupInfo;
